<template>
	<div>
		<div style="background-color: #fff;padding: 1%;text-align: left;">
			<div>
				<el-form :inline="true">
					<el-form-item label="创建时间">
						<el-date-picker v-model="queryTime" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期"
							:default-time="['00:00:00', '23:59:59']"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getDownloadList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="downloadList" style="width: 95%;margin: 1% 2.5%;" size="mini">
			<el-table-column prop="creationTime" label="创建日期" align="center" header-align="center"></el-table-column>
			<el-table-column prop="fileName" label="文件名" align="center" header-align="center"></el-table-column>
			<el-table-column prop="latestStatus" label="最新状态" align="center" header-align="center"></el-table-column>
			<el-table-column prop="address" label="操作" align="center" header-align="center">
				<template  #default="scope">
					<a v-if="scope.row.url" :href="scope.row.url" style="text-decoration:none;color: #409eff;">下载</a>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				downloadList: [],
				queryTime: [new Date(new Date().setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000), new Date(new Date()
					.setHours(23, 59, 59, 0))],
			}
		},
		methods: {
			//获取下载列表
			getDownloadList() {
				this.axios.post('', {
						modules: "downloadList",
						content: {
							startTime: this.queryTime[0],
							endTime: this.queryTime[1]
						}
					})
					.then((res) => {
						if (res.data.status) {
							this.downloadList = res.data.data.downloadList;
						}
					})
			}

		},
		created() {
			try {
				this.getDownloadList()
			} catch (e) {
				console.log(e)
			}
		}
	}
</script>

<style>
</style>